import script from "./Youtube.vue?vue&type=script&setup=true&lang=js"
export * from "./Youtube.vue?vue&type=script&setup=true&lang=js"

import "./Youtube.vue?vue&type=style&index=0&id=ab1d3f2c&scoped=true&lang=scss"

import exportComponent from "/Users/mayo/htdocs/halp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab1d3f2c"]])

export default __exports__